const products = [
  {
    id: 1,
    name: 'Acapulco Gold',
    strain: 'Runtz',
    // thcContent: 'Runtz',
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 60 },
    ],
    image: '/images/icek.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'A Indica-dominant with a sweet berry aroma and euphoric effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 101,
    name: 'Black Cherry Gelato',
    strain: 'Runtz',
    // thcContent: 'Runtz',
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 60 },
    ],
    image: '/images/bmam.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'Black Cherry Gelato is a balanced hybrid strain with sky-high potency and relaxing yet uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 2,
    name: 'OG Kush',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 60 },
    ],
    image: '/images/gpp.png',
    category: 'A+ Flower',
    isNew: true,
    description: 'OG Kush is an indica-heavy hybrid with a breakdown of around 85% indica to 15% sativa.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 4,
    name: 'Maui',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 60 }
    ],
    image: '/images/pipes.png',
    category: 'A+ Flower',
    isNew: true,
    description: 'Maui is a legendary sativa-dominant strain known for its tropical flavors and uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 5,
    name: 'GMO Cookies',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 60 },
    ],
    image: '/images/placeholder.png',
    category: 'A+ Flower',
    isNew: true,
    description: 'GMO Cookie strain is a heavy hitter that is roughly 90% indica and 10% sativa.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  // Flower (8 products)
  {
    id: 3,
    name: 'Lemon Cherry Gelato',
    strain: 'Hybrid',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/phaze.png',
    category: 'A+ Flower',
    isNew: true,
    description: 'Lemon Cherry Gelato is a balanced hybrid strain with sky-high potency, dessert-like flavors, and relaxing yet uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  
  {
    id: 6,
    name: 'Taho OG',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 40 }    ],
    image: '/images/blue.png',
    category: 'Flower',
    isNew: true,
    description: 'A sativa-dominant hybrid with a sweet berry aroma and euphoric effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 7,
    name: 'Lemon OG',
    strain: 'Indica',
    // thcContent: 23,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/og.png',
    category: 'Flower',
    description: 'A classic indica strain with earthy pine aromas and relaxing effects.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Earthy', 'Pine', 'Woody']
  },
  {
    id: 8,
    name: 'Sour Diesel',
    strain: 'Sativa',
    // thcContent: 20,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/sdd.png',
    category: 'Flower',
    isNew: true,
    description: 'A potent sativa with diesel-like aroma and energizing effects.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Diesel', 'Citrus', 'Pungent']
  },
  {
    id: 9,
    name: 'Granddaddy Purple',
    strain: 'Indica',
    // thcContent: 22,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/gpp.png',
    category: 'Flower',
    description: 'A famous indica with grape and berry flavors, perfect for relaxation.',
    effects: ['Relaxing', 'Sleepy', 'Euphoric'],
    flavors: ['Grape', 'Berry', 'Sweet']
  },
  {
    id: 10,
    name: 'Green Crack',
    strain: 'Sativa',
    // thcContent: 19,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/gcc.png',
    category: 'Flower',
    description: 'An energetic sativa with mango and citrus flavors.',
    effects: ['Energetic', 'Focused', 'Happy'],
    flavors: ['Mango', 'Citrus', 'Tropical']
  },
  {
    id: 11,
    name: 'Northern Lights',
    strain: 'Indica',
    // thcContent: 21,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/nlight.png',
    category: 'Flower',
    description: 'A classic indica known for its relaxing and sleep-inducing effects.',
    effects: ['Relaxing', 'Sleepy', 'Peaceful'],
    flavors: ['Earthy', 'Sweet', 'Pine']
  },
  {
    id: 12,
    name: 'Jack Herer',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/jack.png',
    category: 'Flower',
    isNew: true,
    description: 'A legendary sativa with spicy pine flavor and clear-headed effects.',
    effects: ['Creative', 'Focused', 'Uplifted'],
    flavors: ['Pine', 'Spicy', 'Woody']
  },
  {
    id: 13,
    name: 'Wedding Cake',
    strain: 'Hybrid',
    // thcContent: 25,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/weed.png',
    category: 'Flower',
    description: 'A potent hybrid with sweet vanilla flavor and balanced effects.',
    effects: ['Relaxed', 'Happy', 'Euphoric'],
    flavors: ['Vanilla', 'Sweet', 'Creamy']
  },

  // Edibles (5 products)
  {
    id: 14,
    name: 'Trolli Gummi Candy',
    strain: 'Hybrid',
    priceOptions: [
      { option: '1 600mg', price: 30 },

    ],
    image: '/images/troll.png',
    category: 'Edibles',
    isNew: true,
    description: 'Trolli Gummi Candy with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '10mg THC per piece'
  },
  {
    id: 15,
    name: 'Hyfly',
    strain: 'Indica',
    thcContent: 600,
    priceOptions: [
      { option: '1 600mg', price: 30 },

    ],
    image: '/images/hyf.png',
    category: 'Edibles',
    description: 'Hyfly Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '5mg THC per piece'
  },
  {
    id: 16,
    name: 'Stony Patch',
    strain: 'Sativa',
    thcContent: 500,
    priceOptions: [
      { option: '1 500mg', price: 30 },
    ],
    image: '/images/stp.png',
    category: 'Edibles',
    description: 'Stony Patch Gummi with 500mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '15mg THC per piece'
  },
  {
    id: 17,
    name: 'Faded Gummi',
    strain: 'Hybrid',
    thcContent: 1000,
    priceOptions: [
      { option: '1 1000mg', price: 30 },
    ],
    image: '/images/fadd.png',
    category: 'Edibles',
    description: 'Peach Gummi with 1000mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '20mg THC per piece'
  },
  {
    id: 18,
    name: 'Sour rings',
    strain: 'Hybrid',
    thcContent: 600,
    cbdContent: 5,
    priceOptions: [
      { option: '1 600mg', price: 30 },
    ],
    image: '/images/ring.png',
    category: 'Edibles',
    description: 'Sour rings Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '5mg THC + 5mg CBD per piece'
  },

  // Concentrates (2 products)
  {
    id: 19,
    name: 'Moon Rock',
    strain: '2 g',
    // thcContent: 50,
    priceOptions: [
      { option: '2g', price: 50 }
    ],
    image: '/images/moo.png',
    category: 'Concentrates',
    description: '2 grams of Moon Rock concentrate.',
    effects: ['Strong', 'Euphoric', 'Creative'],
    flavors: ['Dank', 'Pine', 'Citrus'],
    consistency: 'Sauce'
  },
  {
    id: 20,
    name: 'Shatter',
    strain: '1g shatter',
    // thcContent: 80,
    priceOptions: [
      { option: '1g', price: 25 }
    ],
    image: '/images/shtt.png',
    category: 'Concentrates',
    description: '1 gram of Shatter concentrate.',
    effects: ['Potent', 'Relaxing', 'Sleepy'],
    flavors: ['Earthy', 'Sweet', 'Pungent'],
    consistency: 'Glass-like'
  },

  // Cartridges (4 products)
  {
    id: 21,
    name: 'Raw Garden',
    strain: 'indica',
    // thcContent: 85,
    priceOptions: [
      { option: '1g', price: 30 }
    ],
    image: '/images/raw.png',
    category: 'cart',
    description: 'Raw Garden vape cartridges generally offer a sweet, fruity flavor profile with indica-dominant effects.',
    effects: ['Happy', 'Relaxed', 'Euphoric'],
    flavors: ['Sweet', 'Creamy', 'Berry'],
    cartridgeType: '510 Thread'
  },
  {
    id: 22,
    name: 'Big Chief',
    strain: 'Sativa',
    // thcContent: 82,
    priceOptions: [
      { option: '1g', price: 30 }
    ],
    image: '/images/bigc.png',
    category: 'cart',
    description: 'Big Chief delivers a refreshing and juicy experience, reminiscent of biting into a ripe watermelon.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Orange', 'Citrus', 'Tangy'],
    cartridgeType: '510 Thread'
  },
  {
    id: 23,
    name: 'Friendly Farms',
    strain: 'Indica',
    // thcContent: 83,
    priceOptions: [
      { option: '1g', price: 30 }
    ],
    image: '/images/fri.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Grape', 'Berry', 'Sweet'],
    cartridgeType: '510 Thread'
  },
  {
    id: 24,
    name: 'Friendly Farms',
    strain: 'Sativa',
    // thcContent: 79,
    priceOptions: [
      { option: '1g', price: 30 }
    ],
    image: '/images/fri2.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Energetic', 'Happy', 'Creative'],
    flavors: ['Strawberry', 'Sweet', 'Fruity'],
    cartridgeType: '510 Thread'
  },

  // Disposable Carts (4 products)
  {
    id: 25,
    name: 'Raw garden Disposable',
    strain: 'Sativa',
    priceOptions: [
      { option: '2g', price: 50 }
    ],
    image: '/images/raw2g.png',
    category: 'disposable-cart',
    weight: '2g',
    description: '2 grams Raw garden Disposable, Liquid Diamonds.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Pineapple', 'Mango', 'Tropical'],
    battery: '300mAh'
  },
  {
    id: 26,
    name: 'Botiq Switch Disposable',
    strain: 'Indica',
    priceOptions: [
      { option: '2g', price: 50 }
    ],
    image: '/images/switch2.png',
    category: 'disposable-cart',
    weight: '2g',
    description: '2 grams Botiq Switch Disposable, Liquid Diamonds.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Blueberry', 'Sweet', 'Earthy'],
    battery: '350mAh'
  },
  {
    id: 27,
    name: 'Pac Man Disposable',
    strain: 'indica',
    priceOptions: [
      { option: '2g', price: 50 }
    ],
    image: '/images/pac2.png',
    category: 'disposable-cart',
    weight: '2g',
    description: '2g Disposable Exotics Edition variety pack 2 gram disposable, Liquid Diamonds.',
    effects: ['Energetic', 'Creative', 'Focused'],
    flavors: ['Orange', 'Citrus', 'Champagne'],
    battery: '300mAh'
  },
  {
    id: 28,
    name: 'Muha Meds Disposable',
    strain: 'Indica',
    priceOptions: [
      { option: '2g', price: 50 }
    ],
    image: '/images/muha2.png',
    category: 'disposable-cart',
    weight: '2g',
    description: '2g Disposable Exotics Edition variety pack 2 gram disposable, Liquid Diamonds.',
    effects: ['Relaxing', 'Euphoric', 'Happy'],
    flavors: ['Tropical', 'Sweet', 'Fruity'],
    battery: '320mAh'
  },

  // Pre-rolls (2 products)
  {
    id: 29,
    name: 'Pre-Roll - Sativa',
    strain: 'Sativa',
    weight: '10 x1g',
    priceOptions: [
      { option: '10 x 1g', price: 100 }
    ],
    image: '/images/prr.png',
    category: 'Pre-rolls',
    description: '10 premium sativa pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Sativa Pre-rolls for 100'],
    quantity: '10 pre-rolls (1g each)'
  },
  {
    id: 30,
    name: 'Pre-Roll - Indica',
    strain: 'Indica',
    weight: '10 x 1g',
    // thcContent: 22,
    priceOptions: [
      { option: '10 x 1g', price: 100 }
    ],
    image: '/images/prr1.png',
    category: 'Pre-rolls',
    description: '10 premium indica pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Indica Pre-rolls for 100'],
    quantity: '10 pre-rolls (1g each)'
  },
  {
    id: 31,
    name: 'Designer Shake - Indica',
    strain: 'Indica',
    weight: '1 oz',
    priceOptions: [
      { option: '1 oz', price: 60 }
    ],
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Designer Shake - Indica.',
  },
  {
    id: 32,
    name: 'Designer Shake - Sativa',
    strain: 'Sativa',
    weight: '1 oz',
    priceOptions: [
      { option: '1 oz', price: 60 }
    ],
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Premium Shake - Sativa.',
  },
   {
    id: 46,
    name: '2 oz Exotic-Flower + gummy',
    strain: 'Exotic flowers Deal',
    weight: '2 oz Exotic-Flower',
    priceOptions: [
      { option: '2 oz Exotic-Flower', price: 350 }
    ],
    image: '/images/icek.png',
    category: 'Deals',
    description: 'your choice of 2 oz Exotic-Flower + gummy for 350',
  },
  {
    id: 47,
    name: 'Half oz Exotic-Flower + Gummy',
    strain: 'Exotic flowers Deal',
    weight: 'Half oz Exotic-Flower',
    priceOptions: [
      { option: 'Half oz Exotic-Flower + Gummy', price: 100 }
    ],
    image: '/images/icek.png',
    category: 'Deals',
    description: 'your choice of Half oz Exotic-Flower and 1 gummy for 100',
  },
  {
    id: 33,
    name: '4 oz flower + 2 pre-rolls',
    strain: 'Premium flowers Deal',
    weight: '4 oz flower + 2 pre-rolls',
    priceOptions: [
      { option: '4 oz Flower', price: 350 }
    ],
    image: '/images/og.png',
    category: 'Deals',
    description: 'your choice of 4 oz flower + 2 pre-rolls for 350',
  },
  {
    id: 34,
    name: '2 oz flower + gummy',
    strain: 'Premium flowers Deal',
    weight: '2 oz flower + gummy',
    priceOptions: [
      { option: '2 oz Flower', price: 200 }
    ],
    image: '/images/og.png',
    category: 'Deals',
    description: 'your choice of 2 oz flower + gummy for 200',
  },
  {
    id: 35,
    name: '2 oz A+ flowers',
    strain: 'Premium A+ flowers Deal',
    weight: '2 oz A+ flowers',
    priceOptions: [
      { option: '2 oz A+ Flowers', price: 280 }
    ],
    image: '/images/phaze.png',
    category: 'Deals',
    description: 'your choice of 2 oz A+ flowers for 280',
  },
  {
    id: 44,
    name: '4 oz A+ flowers + 2 pre-rolls',
    strain: 'Premium A+ flowers Deal',
    weight: '4 oz A+ flowers + 2 pre-rolls',
    priceOptions: [
      { option: '4 oz A+ Flowers', price: 560 }
    ],
    image: '/images/phaze.png',
    category: 'Deals',
    description: 'your choice of 4 oz A+ flowers + 2 pre-rolls for 560',
  },
  {
    id: 36,
    name: '3 Disposables Special (2g)',
    strain: '2g Disposables Deal',
    weight: '3 2g Disposables',
    priceOptions: [
      { option: '3 2g Disposables', price: 130 }
    ],
    image: '/images/dv.png',
    category: 'Deals',
    description: 'your choice of 3 Disposables for 130',
  },
  {
    id: 37,
    name: '10 Disposables Special (2g)',
    strain: '2g Disposables Deal',
    weight: '10 2g Disposables',
    priceOptions: [
      { option: '10 2g Disposables', price: 350 }
    ],
    image: '/images/raw2g.png',
    category: 'Deals',
    description: 'your choice of 10 Disposables for 350',
  },
  {
    id: 38,
    name: '4 Disposables Special (2)',
    strain: '2g Disposables Deal',
    weight: '4 2g Disposables',
    priceOptions: [
      { option: '4 2g Disposables', price: 150 }
    ],
    image: '/images/3gg.png',
    category: 'Deals',
    description: 'your choice of 4 Disposables for 150',
  },

  {
    id: 39,
    name: '10 Carts Special',
    strain: 'Carts Deal',
    weight: '10 carts',
    priceOptions: [
      { option: '10 carts', price: 220 }
    ],
    image: '/images/raw.png',
    category: 'Deals',
    description: 'your choice of 10 carts for 220',
  },
  {
    id: 40,
    name: '4 Carts Special',
    strain: 'Carts Deal',
    weight: '4 carts',
    priceOptions: [
      { option: '4 carts', price: 100 }
    ],
    image: '/images/fri.png',
    category: 'Deals',
    description: 'your choice of 4 carts for 100',
  },
  // {
  //   id: 333,
  //   name: '10 Carts Special',
  //   strain: '',
  //   weight: '10 carts',
  //   priceOptions: [
  //     { option: '10 carts', price: 220 }
  //   ],
  //   image: '/images/raw.png',
  //   category: 'Deals',
  //   description: 'your choice of 10 carts for 220',
  // },
  {
    id: 41,
    name: '4 Edibles Special',
    strain: 'Edibles Deal',
    weight: ' Edibles',
    priceOptions: [
      { option: '4 600Mg Edibles', price: 100 }
    ],
    image: '/images/edd.png',
    category: 'Deals',
    description: 'your choice of 4 600Mg Edibles for 100',
  },
  {
    id: 45,
    name: '10 Edibles Special',
    strain: 'Edibles Deal',
    weight: ' Edibles',
    priceOptions: [
      { option: '10 600Mg Edibles', price: 220 }
    ],
    image: '/images/edd.png',
    category: 'Deals',
    description: 'your choice of 10 600Mg Edibles for 220',
  },
  {
    id: 42,
    name: '10g Shatter Special',
    strain: 'Shatter Deal',
    weight: '10g Shatter',
    priceOptions: [
      { option: '10g Shatter', price: 200 }
    ],
    image: '/images/shtt.png',
    category: 'Deals',
    description: '10g Shatter for 200',
  },
  {
    id: 43,
    name: '28g Shatter Special',
    strain: 'Shatter Deal',
    weight: '28g Shatter',
    priceOptions: [
      { option: '28g Shatter (1 Oz)', price: 500 }
    ],
    image: '/images/shtt.png',
    category: 'Deals',
    description: '28g Shatter (1 Oz) for 500',
  },
  {
    id: 53,
    name: '2 oz Shake Special',
    strain: 'Shake Deal',
    weight: '2 oz Shake',
    priceOptions: [
      { option: 'Shake (2 oz)', price: 100 }
    ],
    image: '/images/shake.png',
    category: 'Deals',
    description: '2 oz Designer Shake for 100',
  },
  {
    id: 53,
    name: '4 oz Shake Special',
    strain: 'Shake Deal',
    weight: '4 oz Shake',
    priceOptions: [
      { option: 'Shake (4 oz)', price: 180 }
    ],
    image: '/images/shake.png',
    category: 'Deals',
    description: '4 oz Designer Shake for 180',
  }
  
];

export default products;